/* eslint-disable @typescript-eslint/no-var-requires */
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import bannerChristmas from '../assets/bannerChristmas.png';
import bannerValentines from '../assets/bannerValentines.png';
import bannerEaster from '../assets/bannerEaster.png';
import bannerHalloween from '../assets/bannerHalloween.png';
import banner from '../assets/banner.png';
import { ControlRecord } from '../ts/Definitions';
import { ProfileRole } from '../ts/enums';

const member = require('../assets/member.png');
const owner = require('../assets/owner.png');
const switchOwner = require('../assets/switch.png');


export const getBannerType = () => {
  if (new Date().getMonth() === 11) return bannerChristmas;
  if (new Date().getMonth() === 1 && new Date().getDate() < 15) return bannerValentines;
  if (new Date().getMonth() === 2 && new Date().getDate() > 14) return bannerEaster;
  if (new Date().getMonth() === 9 && new Date().getDate() > 20) return bannerHalloween;
  return banner;
}

export const getProfileImage = (item: ControlRecord): string => {
  if (!item) return member;
  if (item.profileImage) return item.profileImage;
  if (item.role === ProfileRole.Owner) return owner;
  if (item.role === ProfileRole.Switch) return switchOwner;
  return member;
}

export function getBase64(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    if (file instanceof Blob) {
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    }
  });
}

export async function uploadLockImage(userId: string, key: string, file: Blob, fileName: string): Promise<string | null> {
  try {
    const storage = getStorage();
    const storageRef = ref(storage, `locks/${userId}/${key}/${fileName}`);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  } catch {
    return null;
  }
}